<template>
  <div class="new-main-page">
    <h1 class="new-main-header">
      <img
        src="@/assets/site-wide/protoge-header.png"
        alt="AI Logo"
        class="logo"
      />
    </h1>
    <div class="filter-container">
      <input
        type="text"
        v-model="filterInput"
        placeholder="Filter..."
        class="search-input"
      />
    </div>
    <div class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Start</th>
            <th>Stage</th>
            <th>End</th>
            <th>Select</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="mentee in filteredMentees" :key="mentee.id">
            <td>{{ mentee.name }}</td>
            <td>{{ mentee.start }}</td>
            <td>{{ mentee.stage }}</td>
            <td>{{ mentee.end }}</td>
            <td>
              <label>
                <input
                  type="checkbox"
                  :value="mentee.id"
                  v-model="selectedMentees"
                  @change="selectMentee(mentee)"
                />
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- div -->
    <div class="form-container">
      <p class="form-text">Provide Suggested Session Topic Below:</p>
      <form @submit.prevent="submitSuggestion">
        <textarea
          v-model="suggestion"
          placeholder="Text  that will be sent to all selected mentees chatbot as a suggested coaching topic."
          class="textarea-box"
          rows="10"
        ></textarea>
        <div class="button-container">
          <button type="submit" class="submit-button">Send</button>
        </div>
      </form>
    </div>
    <!-- /div -->
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useSessionStore } from "@/stores/session";
import mentorApi from "@/services/mentor_api"; // Adjust the path as needed

export default {
  name: "MenteesPage",
  setup() {
    const session = useSessionStore();
    const filterInput = ref("");
    const selectedMentees = ref([]);
    const suggestion = ref("");

    const submitSuggestion = async () => {
      // userId, sessionId, suggestion, authToken
      try {
        const response = await mentorApi.sendSuggestion({
          // userId: selectedMentee.value.id,
          sessionId: "session-id", // Adjust as needed
          suggestion: suggestion.value,
        });
        console.log("Suggestion submitted successfully:", response.data);
        // Optionally, clear the suggestion after submission
        suggestion.value = "";
      } catch (error) {
        console.error("Error submitting suggestion:", error);
      }
    };

    const filteredMentees = computed(() => {
      if (!filterInput.value) return session.mentees;
      return session.mentees.filter((mentee) =>
        Object.values(mentee).some((val) =>
          String(val).toLowerCase().includes(filterInput.value.toLowerCase()),
        ),
      );
    });

    const selectMentee = (mentee) => {
      const index = selectedMentees.value.indexOf(mentee.id);
      if (index === -1) {
        selectedMentees.value.push(mentee.id);
      } else {
        selectedMentees.value.splice(index, 1);
      }
      console.log("Selected Mentees:", selectedMentees.value);
    };

    onMounted(async () => {
      // Use dummy data for now
      session.mentees = [
        {
          id: 1,
          name: "John Doe",
          start: "2021-01-01",
          stage: "Stage 1",
          end: "2021-06-01",
        },
        {
          id: 2,
          name: "Jane Smith",
          start: "2021-02-01",
          stage: "Stage 2",
          end: "2021-07-01",
        },
      ];
      // Uncomment the following line to fetch real data from the API
      session.mentees = await mentorApi.getMentees();
    });

    return {
      filterInput,
      filteredMentees,
      selectMentee,
      submitSuggestion,
      suggestion,
    };
  },
};
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70%;
  padding: 20px;
  box-sizing: border-box;
  max-width: 650px;
  justify-content: center;
  margin: 0 auto;
}

.form-container p {
  margin-bottom: 10px;
  margin-top: 5px;
}

.form-group {
  margin-bottom: 15px;
}

.form-text {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}

.table-container {
  margin-top: 20px;
  margin: 0 auto;
  max-width: 80%;
  max-height: 300px;
  overflow-y: auto;
}

.search-input {
  padding: 8px;
  font-size: 16px;
  width: 50%;
  box-sizing: border-box;
  background-color: #f0f0f0;
  border-radius: 10px;
  border: 1px solid #ccc;
}

.data-table {
  width: 100%;
  max-width: 90%;
  margin: 0 auto;
  border-collapse: collapse;
  overflow-y: auto;
}

.data-table td {
  padding: 8px;
  text-align: center;
  border: none;
  font-weight: normal;
}

.data-table th {
  background-color: #e9e5d6;
  text-align: center;
  border: none;
  font-weight: boldest;
}

.filter-container {
  display: flex;
  justify-content: center;
  width: 50%;
  margin-bottom: 10px;
  margin-top: 15px;
  max-width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

tr:hover {
  background-color: #f1f1f1;
}

input[type="text"] {
  margin-bottom: 10px;
  padding: 8px;
  width: 80%;
  box-sizing: border-box;
}

.delete-button {
  background-color: #ca1f67;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.delete-button:hover {
  background-color: #a81b55;
}

.view-button {
  background-color: #1f6dca;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.view-button:hover {
  background-color: #162a6d;
}

.select-box,
.textarea-box {
  width: 100%;
  padding: 2px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  background-color: #f0f0f0;
}

.textarea-box::placeholder {
  font-weight: bold;
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.submit-button {
  background-color: #1f6dca;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

.submit-button:hover {
  background-color: #162a6d;
}

.new-main-page {
  display: flex;
  flex-direction: column;
  height: var(--app-height);
  min-height: 100vh;
  min-height: -webkit-fill-available;
  width: 70%;
  background: #e9e5d6;
}

.new-main-page h1,
.new-main-page p,
.new-main-page form,
.new-main-page div {
  width: 100%;
  text-align: left;
}

.new-main-header {
  display: flex;
  justify-content: left;
  align-items: center;
  height: 150px;
  background-color: #e9e5d6;
  padding: 0;
  margin: 0;
}

.new-main-page-header-text {
  height: 40px;
  margin-top: 2%;
  margin-left: 20%;
}

.new-main-page-header-text {
  font-size: 1.5em;
  margin-top: 2%;
  margin-left: 0%;
  font-family: "Roboto", sans-serif;
}

@media (max-width: 768px) {
  .new-main-page {
    width: 100%; /* Full width on mobile */
    padding: 0 1em; /* Add some padding */
  }

  .filter-container {
    justify-content: left;
  }

  .table-container {
    margin: 0; /* Remove any margin */
    padding: 0; /* Remove any padding */
  }

  .data-table {
    width: 100%; /* Ensure the table takes the full width */
    margin: 0; /* Remove any margin */
  }

  .data-table th,
  .data-table td {
    padding: 8px;
    text-align: left;
  }
  .form-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    max-width: 800px;
    justify-content: left;
    margin: 0 auto;
  }
  .select-box,
  .textarea-box {
    width: 80%;
    padding: 2px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: #f0f0f0;
  }
  .header {
    height: auto;
  }
  .logo {
    width: 100%;
    height: auto;
  }
}
</style>
